<template>
  <div class="question-container">
    <nav-header class="page-header">
      <template #title>
        <label>问题解答</label>
      </template>
    </nav-header>
    <div class="question-con">
      <h4>{{ questionDetail.questionName }}</h4>
      <div class="question-body" v-html="questionDetail.answer"></div>
    </div>
    <div class="bottom">
      <van-divider style="padding:0 50px;">是否有解决您的问题</van-divider>
      <div class="can-select" v-if="!selected">
        <van-button icon="good-job" round @click="handleSelected(true)"
          >已解决</van-button
        >
        <van-button
          icon="good-job"
          round
          @click="handleSelected(false)"
          class="reverse"
          >未解决</van-button
        >
      </div>
      <div class="selected" v-else>
        <van-button icon="good-job" round v-if="resolved">已解决</van-button>
        <van-button icon="good-job" round class="reverse" v-else
          >未解决</van-button
        >
      </div>
    </div>
  </div>
</template>

<script>
import NavHeader from './navHeader.vue';
import { Toast } from 'vant';
import { apiGetQuestionDetail, apiSolveQuestion } from '@/api/knowledgeBase.js';
import moment from 'moment';
export default {
  name: 'knowledgeBase_detail',
  components: {
    NavHeader,
  },
  computed: {
    questionId() {
      return this.$route.query.id;
    },
    checkedKey() {
      return moment().format('YYYYMMDD');
    },
  },
  data() {
    return {
      selected: false,
      resolved: false,
      questionDetail: {},
    };
  },
  methods: {
    initChecked() {
      let checkedKey = moment(new Date()).format('YYYYMMDD');
      let checkedValues = localStorage.getItem(checkedKey)
        ? JSON.parse(localStorage.getItem(checkedKey))
        : [];
      let item = checkedValues.find((item) => {
        if (Object.keys(item).includes(this.questionId)) {
          return item;
        }
      });
      if (item) {
        this.selected = true;
        this.resolved = item[this.questionId];
      }
    },
    getDetail() {
      apiGetQuestionDetail(this.questionId).then((res) => {
        this.questionDetail = res;
      });
    },
    handleSelected(flag) {
      this.selected = true;
      this.resolved = flag;
      let checkedKey = moment(new Date()).format('YYYYMMDD');
      let checkedValues = localStorage.getItem(checkedKey)
        ? JSON.parse(localStorage.getItem(checkedKey))
        : [];
      checkedValues.push({
        [this.questionId]: flag,
      });
      localStorage.setItem(checkedKey, JSON.stringify(checkedValues));

      let data = {
        questionId: this.questionId,
        solveStatus: flag ? 1 : 0,
      };
      apiSolveQuestion(data).then(() => {
        Toast('感谢您的反馈');
        this.resolved = flag;
        this.selected = true;
      });
    },
  },
  mounted() {
    this.getDetail();
    this.initChecked();
  },
};
</script>

<style lang="less">
.question-container {
  background-color: #ffffff;
  box-sizing: border-box;
  .van-icon {
    color: #aaa;
    margin-right: 0;
  }
  .page-header {
    label {
      font-size: 18px;
      color: #111;
    }
  }
  .question-con {
    text-align: left;
    overflow: auto;
    height: calc(~'100vh - 247px');
    padding: 0 20px;
    color: #111;

    h4 {
      font-size: 18px;
      line-height: 25px;
      margin: 26px 0 10px;
    }
    .question-body {
      font-size: 15px;
      line-height: 27px;
      p {
        margin: 12px 0;
      }
      ul,
      ol {
        margin: 12px 0 0 20px;
        list-style: disc;
      }
      ol {
        list-style: decimal;
      }
    }
  }
  .bottom {
    padding: 0 20px 80px 20px;
    color: #999;
    box-sizing: border-box;
    .van-button--default {
      color: #999;
      width: 45%;
      vertical-align: top;
    }
    .can-select button:first-of-type {
      margin-right: 20px;
    }
    .selected {
      .van-button--default {
        color: #999;
        width: 45%;
        background: #f3f5f6;
        border: 0;
      }
      .van-icon {
        color: #ff8e8e;
      }
    }
    .van-icon {
      color: #bebebe;
    }
  }
  .reverse {
    .van-icon {
      transform: rotate(180deg);
    }
  }
}
</style>